import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { PainAgitation } from './components/PainAgitation';
import { MechanismReveal } from './components/MechanismReveal';
import { ProductPresentation } from './components/ProductPresentation';
import { BenefitsTimeline } from './components/BenefitsTimeline';
import { Guarantee } from './components/Guarantee';
import { UrgencyScarcity } from './components/UrgencyScarcity';
import { PricingSection } from './components/PricingSection';
import { CTASection } from './components/CTASection';
import { OneLiners } from './components/OneLiners';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-background font-sans selection:bg-gold-500 selection:text-black" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <PainAgitation data-id="element-3" />
      <MechanismReveal data-id="element-4" />
      <ProductPresentation data-id="element-5" />
      <BenefitsTimeline data-id="element-6" />
      <Guarantee data-id="element-7" />
      <UrgencyScarcity data-id="element-8" />
      <PricingSection data-id="element-9" />
      <CTASection data-id="element-10" />
      <OneLiners data-id="element-11" />
      <FAQSection data-id="element-12" />
      <Footer data-id="element-13" />
    </main>;
}